import React, { useState, useEffect, useRef } from "react";
import { DataTable } from 'primereact/datatable';
import axios from 'axios';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { Toolbar } from 'primereact/toolbar';
import { Paginator } from 'primereact/paginator';
import { Link } from "react-router-dom";
import LoadingSpinner from "../Spinner/LoadingSpinner";
import { useHistory, useLocation } from 'react-router-dom';
import { FileUpload } from 'primereact/fileupload';
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from "primereact/dropdown";
import * as genderData from "./../../enums/Genders"
import * as GlobalEnumData from "./../../enums/GlobalEnum"
import exportData from "../../services/exportToExcelService";
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { ProgressBar } from 'primereact/progressbar';
import { object } from "yup";
import AccessControl from "../AccessControl";
import NoAccess from "../NoAccess";
import { RowsPerPageDropdown } from "../../enums/RowsPerPageOptions";

const AttendeesList = () => {
    // Hooks
    const [participantlist, setParticipantlist] = useState([]);
    const [ActionDisable, setActionDisable] = useState(true);
    const [id, setid] = useState(new Array());
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false); const [rowdataid, setRowDataId] = useState(null);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [dayOfEventScreen, setDayOfEventScreen] = useState();
    const [selectedParticipant, setSelectedParticipant] = useState(null);
    const [totalSize, setTotalSize] = useState(0);
    const [ticketDialog, setTicketdialog] = useState(false);
    const [materialFile, setmatierialfile] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [makePresetParticipant, setMakePresentParticipant] = useState([]);
    const [fullName, setfullName] = useState(null);
    const [filterEmail, setFilterEmail] = useState(null);
    const [filterMobileNo, setFilterMobileNo] = useState(null);
    const [filterCity, setFilterCity] = useState(null);
    const [filterState, setFilterState] = useState(null);
    const [filterCountry, setFilterCountry] = useState(null);
    const [filterBoardingCity, setFilterBoardingCity] = useState(null);
    const [filterHospitalName, setFilterHospitalName] = useState(null);
    const [filterCardNo, setFilterCardNo] = useState(null);
    const [filterCompany, setFilterCompany] = useState(null);
    const [filterAddress, setFilterAddress] = useState(null);
    const [filterSpeciality, setFilterSpeciality] = useState(null);

    // Flags for show/hide columns
    const [companyName, setCompanyName] = useState(false);
    const [attendeeName, setAttendeeName] = useState(false);
    const [attendeePresent, setAttendeePresent] = useState(false);
    const [attendeeCardNo, setAttendeeCardNo] = useState(false);
    const [merchandiseIssue, setMerchandiseIssue] = useState(false);
    const [gender, setGender] = useState(false);
    const [address, setAddress] = useState(false);
    const [certificateIssued, setCertificateIssued] = useState(false);
    const [importExcelFile, setImportExcelFile] = useState(false);
    const [ExportPresentAbsent, setExportPresentAbsent] = useState(false);
    const [isExportExcel, setIsExportExcel] = useState(false);
    const [enableFilter, setEnableFilter] = useState(false);
    const [UntickCheckBox, setUntickCheckBox] = useState(true);
    const fileUploadRef = useRef(null);

    // Const
    const toast = useRef(null);
    const dt = useRef(null);
    const history = useHistory();

    let DayOfEvent = "";
    let ModifyParticipantList = [];

    const lazyState = useRef({
        first: 0,
        rows: RowsPerPageDropdown[0],
        page: 1,
        sortField: null,
        sortOrder: null,
        genderdropdowndata: null,
        filterMerchandiseIssued: null,
        filterCertificateIssued: null,
        filterPresent: null,
        fullName: null,
        filterHospitalName: null,
        filterEmail: null,
        filterMobileNo: null,
        filterCity: null,
        filterCountry: null,
        filterCardNo: null,
        filterAddress: null,
        filterSpeciality: null,
        filterBoardingCity: null,
        filterState: null,
        filterCountry: null,
    }); // For Sorting And Pagination Purpose

    // On Screen Load
    useEffect(() => {
        getparticipantlist();
    }, []);

    //#region Common Methods

    // - Get All Participant Api
    const getparticipantlist = (isExportExcel = false, event, IsPresent = null) => {
        setIsLoading(true);
        if (!isExportExcel) setParticipantlist([]);
        axios.post('/api/Participant/GetAll', {
            paginationRequired: !isExportExcel,
            SortDirection: lazyState.current.sortOrder,
            PageSize: lazyState.current.rows,
            CurrentPageNumber: event && event.rows ? ((event.first / event.rows) + 1) : lazyState.current.page,
            SortField: event && event.sortField ? event.sortField : "Firstname",
            registrationStatus: 'APPROVED',
            CompanyFilter: lazyState.current.filterCompany ? lazyState.current.filterCompany : '',
            FullName: lazyState.current.fullName ? lazyState.current.fullName : null,
            Gender: lazyState.current.genderdropdowndata ? lazyState.current.genderdropdowndata.code : null,
            HospitalName: lazyState.current.filterHospitalName ? lazyState.current.filterHospitalName : null,
            Email: lazyState.current.filterEmail ? lazyState.current.filterEmail : null,
            MobileNo: lazyState.current.filterMobileNo ? lazyState.current.filterMobileNo : null,
            CardNo: lazyState.current.filterCardNo ? lazyState.current.filterCardNo : null,
            City: lazyState.current.filterCity ? lazyState.current.filterCity : null,
            merchandiseIssued: lazyState.current.filterMerchandiseIssued ? lazyState.current.filterMerchandiseIssued.code : null,
            CertificateIssued: lazyState.current.filterCertificateIssued ? lazyState.current.filterCertificateIssued.code : null,
            Address: lazyState.current.filterAddress ? lazyState.current.filterAddress : null,
            Speciality: lazyState.current.filterSpeciality ? lazyState.current.filterSpeciality : null,
            BoardingCity: lazyState.current.filterBoardingCity ? lazyState.current.filterBoardingCity : null,
            State: lazyState.current.filterState ? lazyState.current.filterState : null,
            country: lazyState.current.filterCountry ? lazyState.current.filterCountry : null,
            Present: window.location.href.includes("certificategiven") ? 'true' : (IsPresent != null ? IsPresent.toString() : lazyState.current.filterPresent ? lazyState.current.filterPresent.code : null),
        }).then(Response => {
            if (window.location.href.includes("i-carddetails")) {
                setAttendeeName(true);
                setAttendeeCardNo(true);
                setGender(true);
                setImportExcelFile(true);
                DayOfEvent = "I-Card Detail";
                setDayOfEventScreen(DayOfEvent);
            }
            if (window.location.href.includes("merchandise")) {
                setCompanyName(true);
                setAttendeeName(true);
                setMerchandiseIssue(true);
                DayOfEvent = "Merchandise";
                setDayOfEventScreen("Merchandise");
            }
            if (window.location.href.includes("attendancesummary")) {
                setCompanyName(true);
                setAttendeePresent(true);
                setAttendeeName(true);
                setAttendeeCardNo(true);
                setExportPresentAbsent(true);
                DayOfEvent = "Attendance Summary";
                setDayOfEventScreen("Attendance Summary");
            }
            if (window.location.href.includes("certificategiven")) {
                setCompanyName(true);
                setAttendeeName(true);
                setAddress(true);
                setCertificateIssued(true);
                DayOfEvent = "Certificate Given";
                setDayOfEventScreen("Certificate Given");
            }

            if (!isExportExcel) setParticipantlist([]);
            let tempData = [];
            switch (DayOfEvent) {
                case 'I-Card Detail':
                    for (let dataObj of Response.data.data) {
                        // Pass body data in excelsheets.
                        let allExcelData;
                        let excelcolumnData = {
                            Id: dataObj.id,
                            Name: dataObj.fullName,
                            Hospital: dataObj.hospitalName,
                            Email: dataObj.email,
                            "MobileNo": dataObj.mobileNo,
                            "Gender": dataObj.gender,
                            "City": dataObj.cityname,
                            "CardNo": dataObj.cardNo,
                        }
                        if (selectedColumns.length > 0) {
                            for (let selectedColumn of selectedColumns) {
                                let fieldName = selectedColumn.field;
                                let headerName = selectedColumn.header;
                                excelcolumnData = { ...excelcolumnData, [headerName]: dataObj[fieldName] }
                            }
                            tempData.push(excelcolumnData);
                        } else {
                            allExcelData = {
                                Id: dataObj.id,
                                Name: dataObj.fullName,
                                Hospital: dataObj.hospitalName,
                                Email: dataObj.email,
                                "MobileNo": dataObj.mobileNo,
                                "Gender": dataObj.gender,
                                "City": dataObj.cityname,
                                "CardNo": dataObj.cardNo,
                            }
                            tempData.push(allExcelData);
                        }
                    }
                    if (isExportExcel) {
                        exportData(tempData, DayOfEvent);
                        setIsLoading(false);
                        return false;
                    }
                    setTotalRecords(Response.data.totalRecords);
                    setParticipantlist(Response.data.data);
                    break;

                case 'Merchandise':
                    for (let dataObj of Response.data.data) {
                        // Pass body data in excelsheets.
                        let allExcelData;
                        let excelcolumnData = {
                            Id: dataObj.id,
                            Name: dataObj.fullName,
                            Hospital: dataObj.hospitalName,
                            Company: dataObj.company,
                            Email: dataObj.email,
                            "Mobile No": dataObj.mobileNo,
                            "City": dataObj.cityname,
                            "Merchandise Issue": dataObj.merchandiseIssued == true ? "Yes" : dataObj.merchandiseIssued == false ? "No" : "",
                        }
                        if (selectedColumns.length > 0) {
                            for (let selectedColumn of selectedColumns) {
                                let fieldName = selectedColumn.field;
                                let headerName = selectedColumn.header;
                                excelcolumnData = { ...excelcolumnData, [headerName]: dataObj[fieldName] }
                            }
                            tempData.push(excelcolumnData);
                        } else {
                            allExcelData = {
                                Id: dataObj.id,
                                Name: dataObj.fullName,
                                Hospital: dataObj.hospitalName,
                                Company: dataObj.company,
                                Email: dataObj.email,
                                "Mobile No": dataObj.mobileNo,
                                "City": dataObj.cityname,
                                "Merchandise Issue": dataObj.merchandiseIssued == true ? "Yes" : dataObj.merchandiseIssued == false ? "No" : "",
                            }
                            tempData.push(allExcelData);
                        }
                    }
                    if (isExportExcel) {
                        exportData(tempData, DayOfEvent);
                        setIsLoading(false);
                        return false;
                    }
                    setTotalRecords(Response.data.totalRecords);
                    ModifyParticipantList = Response.data.data.map((TricoConfirmedData) => ({
                        ...TricoConfirmedData,
                        merchandiseIssued: TricoConfirmedData.merchandiseIssued === true ? "Yes" : TricoConfirmedData.merchandiseIssued === false ? 'No' : ''
                    }))
                    setParticipantlist(ModifyParticipantList);
                    break;

                case 'Certificate Given':
                    for (let dataObj of Response.data.data) {
                        // Pass body data in excelsheets.
                        let allExcelData;
                        let excelcolumnData = {
                            Id: dataObj.id,
                            Name: dataObj.fullName,
                            Hospital: dataObj.hospitalName,
                            Company: dataObj.company,
                            Email: dataObj.email,
                            "Mobile No": dataObj.mobileNo,
                            "City": dataObj.cityname,
                            "Address": dataObj.address,
                            "Certificate Issue": dataObj.certificateIssued == true ? "Yes" : dataObj.certificateIssued == false ? "No" : "",
                        }
                        if (selectedColumns.length > 0) {
                            for (let selectedColumn of selectedColumns) {
                                let fieldName = selectedColumn.field;
                                let headerName = selectedColumn.header;
                                excelcolumnData = { ...excelcolumnData, [headerName]: dataObj[fieldName] }
                            }
                            tempData.push(excelcolumnData);
                        } else {
                            allExcelData = {
                                Id: dataObj.id,
                                Name: dataObj.fullName,
                                Hospital: dataObj.hospitalName,
                                Company: dataObj.company,
                                Email: dataObj.email,
                                "Mobile No": dataObj.mobileNo,
                                "City": dataObj.cityname,
                                "Address": dataObj.address,
                                "Certificate Issue": dataObj.certificateIssued == true ? "Yes" : dataObj.certificateIssued == false ? "No" : "",
                            }
                            tempData.push(allExcelData);
                        }
                    }
                    if (isExportExcel) {
                        exportData(tempData, DayOfEvent);
                        setIsLoading(false);
                        return false;
                    }
                    setTotalRecords(Response.data.totalRecords);
                    ModifyParticipantList = Response.data.data.map((TricoConfirmedData) => ({
                        ...TricoConfirmedData,
                        certificateIssued: TricoConfirmedData.certificateIssued === true ? "Yes" : TricoConfirmedData.certificateIssued === false ? 'No' : ''
                    }))
                    setParticipantlist(ModifyParticipantList);
                    break;

                case 'Attendance Summary':
                    for (let dataObj of Response.data.data) {
                        // Pass body data in excelsheets.
                        let allExcelData;
                        let excelcolumnData = {
                            Id: dataObj.id,
                            Name: dataObj.fullName,
                            Hospital: dataObj.hospitalName,
                            Company: dataObj.company,
                            Email: dataObj.email,
                            "Mobile No": dataObj.mobileNo,
                            "City": dataObj.cityname,
                            "Present": dataObj.present == true ? "Yes" : dataObj.present == false ? "No" : "",
                            "CardNo": dataObj.cardNo,
                        }
                        if (selectedColumns.length > 0) {
                            for (let selectedColumn of selectedColumns) {
                                let fieldName = selectedColumn.field;
                                let headerName = selectedColumn.header;
                                excelcolumnData = { ...excelcolumnData, [headerName]: dataObj[fieldName] }
                            }
                            tempData.push(excelcolumnData);
                        } else if (isExportExcel && IsPresent != null) {
                            allExcelData = {
                                Id: dataObj.id,
                                Name: dataObj.fullName,
                                Hospital: dataObj.hospitalName,
                                Company: dataObj.company,
                                Email: dataObj.email,
                                "Mobile No": dataObj.mobileNo,
                                "City": dataObj.cityname,
                                "CardNo": dataObj.cardNo,
                            }
                            tempData.push(allExcelData);
                        }
                        else {
                            allExcelData = {
                                Id: dataObj.id,
                                Name: dataObj.fullName,
                                Hospital: dataObj.hospitalName,
                                Company: dataObj.company,
                                Email: dataObj.email,
                                "Mobile No": dataObj.mobileNo,
                                "City": dataObj.cityname,
                                "Present": dataObj.present == true ? "Yes" : dataObj.present == false ? "No" : "",
                                "CardNo": dataObj.cardNo,
                            }
                            tempData.push(allExcelData);
                        }
                    }
                    if (isExportExcel) {
                        exportData(tempData, DayOfEvent);
                        setIsLoading(false);
                        return false;
                    }
                    setTotalRecords(Response.data.totalRecords);
                    ModifyParticipantList = Response.data.data.map((TricoConfirmedData) => ({
                        ...TricoConfirmedData,
                        present: TricoConfirmedData.present === true ? "Yes" : TricoConfirmedData.present === false ? 'No' : ''
                    }))
                    setParticipantlist(ModifyParticipantList);
                    break;
            }
            setIsLoading(false);
        })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    //pagination
    const onBasicPageChange = (event) => {
        // const newPage = event.first / event.rows + 1;
        // if (newPage !== lazyState.current.first / lazyState.current.rows + 1) {
            setIsLoading(true);
            lazyState.current.sortField = lazyState.current.sortField;
            lazyState.current.sortOrder = lazyState.current.sortOrder;
            lazyState.current.first = event.first;
            lazyState.current.rows = event.rows;
            getparticipantlist(false, lazyState.current, null);
            setIsLoading(false);
        // };
    }

    //Template for pagination
    const template2 = {
        layout: ' CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
        'CurrentPageReport': (options) => {
            return (<span className="paginator-current-report" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Showing {options.first} to {options.last} of {options.totalRecords} entries</span>)
        }
    };

    const openNew = () => {
        setmatierialfile([])
        setSubmitted(false);
        setTicketdialog(true);
    }

    const removeFilter = () => {
        lazyState.current.fullName = null;
        setfullName(null);
        lazyState.current.filterHospitalName = null;
        setFilterHospitalName(null);
        lazyState.current.filterCompany = null;
        setFilterCompany(null);
        lazyState.current.filterEmail = null;
        setFilterEmail(null);
        lazyState.current.filterMobileNo = null;
        setFilterMobileNo(null);
        lazyState.current.filterCity = null;
        setFilterCity(null);
        lazyState.current.filterPresent = null;
        lazyState.current.genderdropdowndata = null;
        lazyState.current.filterMerchandiseIssued = null;
        lazyState.current.filterCertificateIssued = null;
        lazyState.current.filterSpeciality = null;
        setFilterSpeciality(null);
        lazyState.current.filterBoardingCity = null;
        setFilterBoardingCity(null);
        lazyState.current.filterState = null;
        setFilterState(null);
        lazyState.current.filterCountry = null;
        setFilterCountry(null);
        lazyState.current.filterCardNo = null;
        setFilterCardNo(null);
        lazyState.current.filterAddress = null;
        setFilterAddress(null);
        getparticipantlist(false);
    }

    // Left Side Toolbar
    const leftToolbarTemplate = () => {
        return (
            <AccessControl allowedPermissions={["list:dayofevent"]}>
                <div className="my-2">
                    {certificateIssued ? <Button disabled={ActionDisable} label="Certificate Issued" tooltip="Certificate Issued" tooltipOptions={{ position: "bottom", className: "showtooltip" }} className="p-button-success mr-2" icon="fa fa-check" onClick={() => InsertCertificateIssued(id)}></Button> : null}
                    {merchandiseIssue ? <Button disabled={ActionDisable} label="Merchandise Issued" tooltip="Merchandise Issued" tooltipOptions={{ position: "bottom", className: "showtooltip" }} className="p-button-success mr-2" icon="fa fa-check" onClick={() => InsertMerchandiseIssued(id)}></Button> : null}
                    {importExcelFile ? <FileUpload disabled={!(participantlist != null && participantlist.length > 0)} tooltip="Import Card No" tooltipOptions={{ position: "bottom", className: "showtooltip" }} chooseOptions={{ label: 'Import Card No', icon: 'pi pi-file-excel', className: 'p-button-success' }} mode="basic" auto url='https://www.primefaces.org/primereact-v8/upload.php'
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" className="mr-2" onUpload={importCardNo} /> : null}
                    {ExportPresentAbsent ? <Button name="Present" disabled={!(participantlist != null && participantlist.length > 0)} tooltip="Export Present" tooltipOptions={{ position: "bottom", className: "showtooltip" }} onClick={(e) => { exportAttendees(e); }} icon="pi pi-file-excel " className="p-button-success mr-2" label="Export Present"></Button> : null}
                    {ExportPresentAbsent ? <Button name="Absent" disabled={!(participantlist != null && participantlist.length > 0)} tooltip="Export Absent" tooltipOptions={{ position: "bottom", className: "showtooltip" }} onClick={(e) => { exportAttendees(e); }} icon="pi pi-file-excel " className="p-button-success mr-2" label="Export Absent"></Button> : null}
                    {dayOfEventScreen == "Attendance Summary" ?
                        <Button icon="fa fa-upload" className="p-button-success mr-2" onClick={openNew} tooltip="Make Present" tooltipOptions={{ position: "bottom", className: "showtooltip" }}  label="Make Present"></Button>
                        : null}
                </div>
            </AccessControl>
        )
    }

    // Right Side Toolbar
    const rightToolbarTemplate = () => {
        return (
            <div className="my-2">
                <AccessControl allowedPermissions={["list:dayofevent"]}>
                    <Button icon="fa fa-solid fa-refresh" className="p-button-outlined mr-2" onClick={() => removeFilter()} tooltip="Reset Filter Records" tooltipOptions={{ position: "bottom", className: "showtooltip" }}></Button>
                    {enableFilter ? <Button type="button" icon="pi pi-filter-slash" tooltip="Hide Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} className=" mr-2 p-button-primary" onClick={(e) => setEnableFilter(false)} /> : <Button type="button" icon="pi pi-filter" tooltip="Show Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} className="p-button-outlined mr-2" onClick={(e) => setEnableFilter(true)} />}
                    <div className="my-2">{header}</div>
                </AccessControl>
                <AccessControl allowedPermissions={["export:dayofevent"]}>
                    <Button disabled={!(participantlist != null && participantlist.length > 0)} tooltip="Export Excel" tooltipOptions={{ position: "bottom", className: "showtooltip" }} onClick={() => { exportExcel(); }} icon="pi pi-file-excel" className="p-button-success mr-2" />
                </AccessControl>
            </div>
        )
    }

    //For Email
    const ButtonMailto = (rowData) => {
        return (
            <Link
                to='#'
                onClick={(e) => {
                    window.location.href = `mailto:${rowData.email}`;
                    e.preventDefault();
                }}
            >{rowData.email}
            </Link>
        );
    };

    //For Mobile No
    const ButtonPhoneto = (rowData) => {
        return (
            <Link
                to='#'
                onClick={(e) => {
                    window.location.href = `tel:${rowData.mobileNo}`;
                    e.preventDefault();
                }}
            >{rowData.mobileNo}
            </Link>
        );
    };

    // For Sorting
    const onSort = (event) => {
        lazyState.current.sortField = event.sortField;
        lazyState.current.sortOrder = event.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        //lazyState.current = event;
        getparticipantlist(false, lazyState.current, null);
    };
    //#endregion

    //#region Method for view attendees 
    const ViewAttendees = (rowData) => {
        return (
            <Link
                to='#'
                onClick={(e) => {
                    history.push('/home/viewparticipant/' + rowData.id)
                }}
            >{rowData.fullName}
            </Link>
        );
    };
    //#endregion

    //#region Method for export excel

    const exportExcel = () => {
        getparticipantlist(true, null);
    }

    //#endregion

    //#region Method for Import Card No
    const toCapitalize = (s) => {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    const importCardNo = (e, processName = "") => {
        const file = e.files[0];
        import('xlsx').then(xlsx => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const wb = xlsx.read(e.target.result, { type: 'array' });
                const wsname = processName != "" ? "Exception Stat." : wb.SheetNames[0];
                const header = processName != "" ? ['ID', 'Name', 'Department', 'Date', 'On-duty', 'Off-duty'] : 1
                const ws = wb.Sheets[wsname];
                const data = xlsx.utils.sheet_to_json(ws, { header: header });

                // Prepare DataTable
                const cols = data[0];
                data.shift();

                if (processName == "MakePresent") {
                    let particpantData = [];
                    data.forEach(element => {
                        if (element['ID'] && element['On-duty'] && element['Off-duty']) {
                            particpantData.push({
                                name: element['Name'],
                                SerialNumber: parseInt(element['ID'])
                            })
                        }
                    })
                    setMakePresentParticipant(particpantData);
                } else {
                    let [colId, colName, colHospital, colEmail, colMobileNo, colGender, colCity, colCardNo] = cols;
                    if (colId == "Id" && colName == "Name" && colHospital == "Hospital" && colEmail == "Email" && colMobileNo == "MobileNo" && colGender == "Gender" && colCity == "City" && colCardNo == "CardNo") {
                        let _importedCols = cols.map(col => ({ field: col, header: toCapitalize(col) }));
                        let _importedData = data.map(d => {
                            return cols.reduce((obj, c, i) => {
                                obj[c] = d[i];
                                return obj;
                            }, {});
                        });
                        if (_importedData.length > 0) {
                            setIsLoading(true);
                            for (const dataObj of _importedData) {
                                if (dataObj.CardNo == undefined) {
                                    dataObj.CardNo = '';
                                }
                                if (!isNaN(dataObj.CardNo)) {
                                    dataObj.CardNo = dataObj.CardNo.toString();
                                    dataObj.CardNo = dataObj.CardNo.slice(-10);
                                    UpdateCardNo(dataObj);
                                } else {
                                    dataObj.CardNo = '';
                                }
                            };
                            setIsLoading(false);
                            getparticipantlist(isExportExcel, null);
                        }

                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'Invalid', detail: 'This file is not valid', life: 3000 });
                    }
                }
            };
            reader.readAsArrayBuffer(file);
        });
    }

    const UpdateCardNo = (attendeeData) => {
        const url = '/api/Participant/updateparticipantbymultiple';
        const data = {
            "Id": attendeeData.Id,
            "CardNo": attendeeData.CardNo,
        }
        axios.put(url, data)
            .then(res => { })
    }
    //#endregion

    //#region Method for filteration

    const UserFilterOnEnter = (e) => {
        if (e.key == "Enter") {
            setIsLoading(true);
            let data = e.target.id;
            switch (data) {
                case "fullName":
                    lazyState.current.fullName = e.target.value ? e.target.value : null
                    break;
                case "hospital":
                    lazyState.current.filterHospitalName = e.target.value ? e.target.value : null
                    break;
                case "company":
                    lazyState.current.filterCompany = e.target.value ? e.target.value : null
                    break;
                case "Email":
                    lazyState.current.filterEmail = e.target.value ? e.target.value : null
                    break;
                case "MobileNo":
                    lazyState.current.filterMobileNo = e.target.value ? e.target.value : null
                    break;
                case "city":
                    lazyState.current.filterCity = e.target.value ? e.target.value : null
                    break;
                case "CardNo":
                    lazyState.current.filterCardNo = e.target.value ? e.target.value : null
                    break;
                case "address":
                    lazyState.current.filterAddress = e.target.value ? e.target.value : null
                    break;
                case "speciality":
                    lazyState.current.filterSpeciality = e.target.value ? e.target.value : null
                    break;
                case "boardingcity":
                    lazyState.current.filterBoardingCity = e.target.value ? e.target.value : null
                    break;
                case "state":
                    lazyState.current.filterState = e.target.value ? e.target.value : null
                    break;
                case "country":
                    lazyState.current.filterCountry = e.target.value ? e.target.value : null
                    break;
            }
            getparticipantlist();
            setIsLoading(false);
        } else {
            setIsLoading(true);
            let data = e.target.id;
            switch (data) {
                case "fullName":
                    lazyState.current.fullName = null
                    break;
                case "hospital":
                    lazyState.current.filterHospitalName = null
                    break;
                case "company":
                    lazyState.current.filterCompany = null
                    break;
                case "Email":
                    lazyState.current.filterEmail = null
                    break;
                case "MobileNo":
                    lazyState.current.filterMobileNo = null
                    break;
                case "city":
                    lazyState.current.filterCity = null
                    break;
                case "CardNo":
                    lazyState.current.filterCardNo = null
                    break;
                case "address":
                    lazyState.current.filterAddress = null
                    break;
                case "speciality":
                    lazyState.current.filterSpeciality = null
                    break;
                case "boardingcity":
                    lazyState.current.filterBoardingCity = null
                    break;
                case "state":
                    lazyState.current.filterState = null
                    break;
                case "country":
                    lazyState.current.filterCountry = null
                    break;
            }
            getparticipantlist();
            setIsLoading(false);
        }
    };

    const UserFilterTemplate = () => {
        return (
            <InputText id="fullName" required autoFocus value={fullName} placeholder="Enter FirstName"
                onChange={(e) => setfullName(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const HospitalFilterTemplate = () => {
        return (
            <InputText id="hospital" required value={filterHospitalName} placeholder="Enter Hospital"
                onChange={(e) => setFilterHospitalName(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const EmailFilterTemplate = () => {
        return (
            <InputText id="Email" required value={filterEmail} placeholder="Enter Email"
                onChange={(e) => setFilterEmail(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const MobileFilterTemplate = () => {
        return (
            <InputText id="MobileNo" required value={filterMobileNo} placeholder="Enter Mobile no"
                onChange={(e) => setFilterMobileNo(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const CardNoFilterTemplate = () => {
        return (
            <InputText id="CardNo" required value={filterCardNo} placeholder="Enter Card No"
                onChange={(e) => setFilterCardNo(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const CompanyFilterTemplate = () => {
        return (
            <InputText id="company" required value={filterCompany} placeholder="Enter Company"
                onChange={(e) => setFilterCompany(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const CityFilterTemplate = () => {
        return (
            <InputText id="city" required value={filterCity} placeholder="Enter City"
                onChange={(e) => setFilterCity(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const AddressFilterTemplate = () => {
        return (
            <InputText id="address" required value={filterAddress} placeholder="Enter Address"
                onChange={(e) => setFilterAddress(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const MerchandiseIssuedFilterTemplate = () => {
        return (
            <Dropdown value={lazyState.current.filterMerchandiseIssued} options={GlobalEnumData.GlobalEnum} optionLabel="name" showClear
                onChange={(e) => { lazyState.current.filterMerchandiseIssued = (e.target.value ? e.target.value : null); getparticipantlist(); e.preventDefault() }} placeholder="Select Merchandise" className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };

    const CertificateIssuedFilterTemplate = () => {
        return (
            <Dropdown value={lazyState.current.filterCertificateIssued} options={GlobalEnumData.GlobalEnum} optionLabel="name" showClear onChange={(e) => { lazyState.current.filterCertificateIssued = (e.target.value ? e.target.value : null); getparticipantlist(); e.preventDefault() }} placeholder="Select Certificate Issued" className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };

    const PresentFilterTemplate = () => {
        return (
            <Dropdown value={lazyState.current.filterPresent} options={GlobalEnumData.GlobalEnum} optionLabel="name" showClear onChange={(e) => { lazyState.current.filterPresent = (e.target.value ? e.target.value : null); getparticipantlist(); e.preventDefault() }} placeholder="Select Present" className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };

    const GenderFilterTemplate = () => {
        return (
            <Dropdown value={lazyState.current.genderdropdowndata} options={genderData.Gender} optionLabel="name" showClear onChange={(e) => { lazyState.current.genderdropdowndata = (e.target.value ? e.target.value : null); getparticipantlist(); e.preventDefault() }} placeholder="Select Gender" className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };

    const SpecialityFilterTemplate = () => {
        return (
            <InputText id="speciality" required value={filterSpeciality} placeholder="Enter Speciality"
                onChange={(e) => setFilterSpeciality(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const BoardingCityFilterTemplate = () => {
        return (
            <InputText id="boardingcity" required value={filterBoardingCity} placeholder="Enter Boarding City"
                onChange={(e) => setFilterBoardingCity(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const StateFilterTemplate = () => {
        return (
            <InputText id="state" required value={filterState} placeholder="Enter State"
                onChange={(e) => setFilterState(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const CountryFilterTemplate = () => {
        return (
            <InputText id="country" required value={filterCountry} placeholder="Enter Country"
                onChange={(e) => setFilterCountry(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };



    //#endregion

    //#region Export excel for Present/Absent Attendees
    const exportAttendees = (e) => {
        getparticipantlist(true, null, (e.target.name == "Present" ? true : false))
    }
    //#endregion

    //#region Methods for screen wise

    //#region Certificate Given
    //Insert Certificate Issued Or Not
    const InsertCertificateIssued = () => {
        setIsLoading(true);
        axios.put('/api/Participant/updateparticipantbymultiple', {
            "Id": id.toString(),
            "CertificateIssued": true
        })
            .then(res => {
                setIsLoading(false);
                setSelectedParticipant([]);
                history.push('/home/dayofevent/certificategiven');
                getparticipantlist(false, lazyState.current, null);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Successful', life: 3000 });
            })
    }
    //#endregion

    //#region Merchandise
    //Insert Merchandise Issued Or Not
    const InsertMerchandiseIssued = () => {
        setIsLoading(true);
        axios.put('/api/Participant/updateparticipantbymultiple', {
            "Id": id.toString(),
            "merchandiseIssued": true
        })
            .then(res => {
                setIsLoading(false);
                setSelectedParticipant([]);
                history.push('/home/dayofevent/merchandise');
                getparticipantlist(false, lazyState.current, null);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Successful', life: 3000 });
            })
    }
    //#endregion

    //#region Certification Given and Merchandise
    // Row Selection / Unselect Functions
    const onAllRowSelect = (e) => {
        setActionDisable(false);
        setid(e.data.map((i, k) => {
            return i.id
        }))
    };

    const onRowSelect = (event) => {
        setActionDisable(false);
        setid((ing) => [...ing, event.data.id])
    }

    const onRowUnselect = (event) => {
        if (id != undefined) {
            var removeidfromdata = id.indexOf(event.data.id);
            id.splice(removeidfromdata, 1);
            if (id.length == 0) {
                setActionDisable(true);
            }
        } else {
            var removefromarray = id.indexOf(event.data.id);
            id.splice(removefromarray, 1);
        }
    }

    const onAllRowUnSelect = (e) => {
        setActionDisable(true);
        setid(e.data.map((i, k) => {
            return i.id
        }))
        id.splice(0, id.length);
    };
    //#endregion

    //#endregion

    //#region File upload template
    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column h-5rem">
                <i className="fa fa-upload " style={{ height: '3rem', fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Upload your Attendance sheet here
                </span>
            </div>
        );
    };

    const headerTemplate = (options) => {
        const { className, chooseButton } = options;
        const value = totalSize / 10000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {/* <Button icon="fa fa-times" className="p-button-outlined p-button-warning p-button-rounded"></Button> */}
                <div className="flex align-items-center gap-3 ml-auto">
                    <span className="mr-2">{formatedValue} / 1 MB </span>
                    <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                </div>
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '70%' }}>
                    <img role="presentation" src={file.objectURL} />
                    <span className="flex flex-column text-left ">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag severity="warning" />
                <Button type="button" icon="fa fa-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto " style={{ width: '2.5rem', height: '2.5rem' }} />
            </div>

        );
    };

    const UpdateParticipantAttendance = () => {
        const url = '/api/Participant/UpdateParticipantPresence';
        const data = makePresetParticipant;
        axios.post(url, data)
            .then(res => {
                setIsLoading(false);
                setTicketdialog(false);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Attendance Updated Successfully', life: 3000 });
                getparticipantlist(isExportExcel, null);
            })
    }

    const ticketDialogFooter = (
        <div className="mt-0">
            <Button label="Submit" icon="fa fa-check" className="p-button-success" onClick={UpdateParticipantAttendance} />
            <Button label="Cancel" icon="fa fa-times" className="p-button-secondary" onClick={(e) => setTicketdialog(false)} />
        </div>
    );

    const onSelect = (e) => {
        let data = []
        let _totalSize = totalSize;
        for (var i = 0; i < e.files.length; i++) {
            if (e.files[i].type.includes(".sheet")) {
                data.push(e.files[i]);
            }
        }
        Object.keys(data).forEach((key) => {
            _totalSize += data[key].size || 0;
        });
        setTotalSize(_totalSize);
        setmatierialfile(data);
    }
    //#endregion

    //#region Method for Column toggle
    const hidecolumns = [
        { field: "speciality", header: "Speciality" },
        { field: "boardingcityname", header: "Boarding City" },
        { field: "statename", header: "State" },
        { field: "countryname", header: "Country" },
    ];

    let unSelectedColumns = [];
    const onColumnToggle = (event) => {
        let selectedColumns = event.value;
        let orderedSelectedColumns = hidecolumns.filter(col => selectedColumns.some(sCol => sCol.field === col.field));
        unSelectedColumns = hidecolumns.filter(o => !selectedColumns.some(i => i.field === o.field && i.header === o.header));
        unselectedColumnData();
        setSelectedColumns(orderedSelectedColumns);
    }

    const unselectedColumnData = () => {
        let isFiltered = false;
        if (unSelectedColumns) {
            unSelectedColumns.map(col => {
                switch (col.header) {
                    case "Speciality":
                        if (lazyState.current.filterSpeciality != null) {
                            lazyState.current.filterSpeciality = null;
                            isFiltered = true;
                            return setFilterSpeciality(null);
                        }
                        break;
                    case "Boarding City":
                        if (lazyState.current.filterBoardingCity != null) {
                            lazyState.current.filterBoardingCity = null;
                            isFiltered = true;
                            return setFilterBoardingCity(null);
                        }
                        break;
                    case "State":
                        if (lazyState.current.filterState != null) {
                            lazyState.current.filterState = null;
                            isFiltered = true;
                            return setFilterState(null);
                        }
                        break;
                    case "Country":
                        if (lazyState.current.filterCountry != null) {
                            lazyState.current.filterCountry = null;
                            isFiltered = true;
                            return setFilterCountry(null);
                        }
                        break;
                }
            });
            if (isFiltered) {
                getparticipantlist();
            }
        }
    }

    const header = (
        <div style={{ textAlign: 'left', marginRight: '10px' }}>
            <MultiSelect value={selectedColumns} options={hidecolumns} optionLabel="header" placeholder="More Columns" onChange={onColumnToggle} style={{ width: '20em' }} display="chip" />
        </div>
    );

    const sortColumn = {
        "Speciality": 'Speciality',
    }

    const hidecolumnComponents = selectedColumns.map(col => {
        return <Column key={col.field} field={col.field} header={col.header} sortable sortField={sortColumn[col.header]} headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} 
        filterElement={col.header == 'Speciality' ? SpecialityFilterTemplate : col.header == 'Boarding City' ? BoardingCityFilterTemplate : col.header == "State" ? StateFilterTemplate : CountryFilterTemplate} />;
    });

    //#endregion

    return (
        <AccessControl allowedPermissions={["list:dayofevent"]} renderNoAccess={() => <NoAccess />} >
            <div className="trico-Grid">
                <Toast ref={toast} />
                {isLoading ? <LoadingSpinner /> :
                    (
                        <>
                            <div className="p-col">
                                <div className="card">
                                    <h5><span><i class="fa fa-list mr-2"></i>{dayOfEventScreen}</span></h5>
                                    <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                                    <DataTable size="small" stripedRows ref={dt} value={participantlist} filterDisplay={enableFilter ? "row" : null}
                                        selectionMode={"checkbox"} onAllRowsSelect={onAllRowSelect}
                                        lazy rows={lazyState.current.rows} onSort={onSort} sortField={lazyState.current.sortField} sortOrder={lazyState.current.sortOrder} removableSort
                                        selection={selectedParticipant} onSelectionChange={(e) => setSelectedParticipant(e.value)} onRowSelect={onRowSelect}
                                        onRowUnselect={onRowUnselect} onAllRowsUnselect={onAllRowUnSelect}
                                        dataKey="id" className="datatable-responsive" responsiveLayout="scroll" scrollable>
                                        <Column frozen className={merchandiseIssue || certificateIssued ? "" : "hidden"} selectionMode="multiple" headerStyle={{ width: '1%', minWidth: '1rem' }}></Column>
                                        {/* <div style={{ display: "none" }}>
                                        <Column field="id" header="ID" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                                        </div> */}
                                        {attendeeName ? <Column body={ViewAttendees} sortField="Firstname" frozen className="font-bold" field="fullName" header="Name" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={UserFilterTemplate}></Column> : null}
                                        {/* <Column field="hospitalName" header="Hospital" sortField="HospitalName" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={HospitalFilterTemplate} ></Column> */}
                                        {companyName ? <Column field="company" header="Company" sortField="Companyname" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={CompanyFilterTemplate} ></Column> : null}
                                        {/* <Column body={ButtonMailto} header="Email" sortField="Email" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={EmailFilterTemplate} ></Column> */}
                                        <Column body={ButtonPhoneto} header="Mobile No" sortField="MobileNo" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={MobileFilterTemplate}></Column>
                                        {/* {gender ? <Column field="gender" header="Gender" sortField="Gender" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={GenderFilterTemplate} ></Column> : null} */}
                                        {/* <Column field="cityname" header="City" sortField="cityname" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={CityFilterTemplate}></Column> */}
                                        {/* {address ? <Column field="address" header="Address" sortField="Address" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={AddressFilterTemplate}></Column> : null} */}
                                        {attendeePresent ? <Column field="present" header="Present" sortField="Present" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={PresentFilterTemplate}></Column> : null}
                                        {attendeeCardNo ? <Column field="cardNo" header="Card No" sortField="CardNo" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={CardNoFilterTemplate}></Column> : null}
                                        {merchandiseIssue ? <Column field="merchandiseIssued" header="Merchandise Issue" sortField="MerchandiseIssued" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={MerchandiseIssuedFilterTemplate}></Column> : null}
                                        {certificateIssued ? <Column field="certificateIssued" header="Certificate Issue" sortField="CertificateIssued" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={CertificateIssuedFilterTemplate} ></Column> : null}
                                        {hidecolumnComponents}
                                    </DataTable>
                                    <Paginator className='justify-content-start' style={{ display: 'block' }} first={lazyState.current.first} rows={lazyState.current.rows} totalRecords={totalRecords} template={template2} rowsPerPageOptions={RowsPerPageDropdown} onPageChange={onBasicPageChange} ></Paginator>
                                    <Dialog visible={ticketDialog} draggable={false} style={{ width: '500px' }} header={'Upload Attendance Sheet'} modal className="p-fluid" footer={ticketDialogFooter} onHide={(e) => setTicketdialog(false)}>
                                        <div className="field mb-0">
                                            <label htmlFor="name" className="font-bold">Choose Files :</label>
                                            <FileUpload ref={fileUploadRef} multiple={true} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onUpload={(e) => importCardNo(e, "MakePresent")} auto onSelect={(e) => onSelect(e)} emptyTemplate={emptyTemplate} headerTemplate={headerTemplate} itemTemplate={itemTemplate}
                                                url='https://www.primefaces.org/primereact-v8/upload.php'
                                                className={submitted && materialFile.length < 1 ? "p-invalid" : ''} ></FileUpload>
                                            {submitted && materialFile.length < 1 && <small className="p-invalid">Please select atleast one file.</small>}
                                        </div>
                                    </Dialog>
                                </div>
                            </div >

                        </>
                    )
                }
            </div>
        </AccessControl>
    )
}
export default AttendeesList;